import Store from '@/Services/Store';
import Order from "@/Services/Order";

export default {
  applyUrlQueryParams() {
    let searchParams = new URLSearchParams(window.location.search);

    for (let productId of searchParams.getAll('product[]')) {
      const index = Store.state.products.findIndex(p => p.code == productId);

      if (Store.state.products[index].quantity == 0) {
        Store.state.products[index].quantity = 1;
      }
    }

    if (searchParams.has('product')) {
      const index = Store.state.products.findIndex(p => p.code == searchParams.get('product'));

      if (Store.state.products[index].quantity == 0) {
        Store.state.products[index].quantity = 1;
      }
    }
  },

  isOrderCompleted() {
    let searchParams = new URLSearchParams(window.location.search);

    const isCompleted = searchParams.has('status') && searchParams.get('status') === 'success';

    if (isCompleted) {
      Order.clear();
    }

    return isCompleted;
  },
};
